import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home/Index.vue')
  },
  {
    path: '/region/:region/profile/:battleTag',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Profile/Index.vue')
  },
  {
    path: '/region/:region/profile/:battleTag/hero/:heroId',
    name: 'Hero',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Hero/Index.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '@/views/About/Index.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import(/* webpackChunkName: "Error" */ '@/views/Error/Index.vue')
  }
]

const router = new Router({
  routes
})

export default router
